import { useState } from "react";
import { GripVertical, RefreshCw } from "lucide-react";
import { resolveTile } from "@/lib/gallery";
import { roomTiles, pct } from "@/lib/layouts";

export function GalleryGrid({ mb, project, index: i, imageBusy, busyTile, onReorder, onRegenTile }) {
  const [drag, setDrag] = useState(null);
  const [over, setOver] = useState(null);
  const count = mb.image_count || 3;
  const gallery = (mb.gallery || []).slice(0, count);
  const tiles = roomTiles(mb.layout || "hero", gallery.length || count);

  const drop = (to) => {
    if (drag === null || drag === to) { setDrag(null); setOver(null); return; }
    const next = [...(mb.gallery || [])];
    const [moved] = next.splice(drag, 1);
    next.splice(to, 0, moved);
    onReorder(next);
    setDrag(null); setOver(null);
  };

  return (
    <div>
      <div className="relative aspect-[16/9] bg-white border overflow-hidden" style={{ borderColor: "#DCDCD5" }} data-testid={`moodboard-gallery-${i}`}>
        {mb.layout !== "editorial" && (
          <div className="absolute text-[10px] font-mono-lab uppercase tracking-wider text-stone-300 pointer-events-none"
            style={mb.layout === "grid" ? { left: "4%", top: "8%" } : { left: "6%", top: "16%" }}>{mb.room} · text column</div>
        )}
        {gallery.map((item, j) => {
          const src = resolveTile(item, mb, project);
          return (
            <div key={`${item.type}-${item.id || item.url || j}`} draggable
              onDragStart={() => setDrag(j)} onDragOver={(e) => { e.preventDefault(); setOver(j); }} onDragLeave={() => setOver(null)}
              onDrop={() => drop(j)} onDragEnd={() => { setDrag(null); setOver(null); }}
              data-testid={`moodboard-tile-${i}-${j}`} style={pct(tiles[j])}
              className={`absolute overflow-hidden bg-stone-100 group cursor-grab active:cursor-grabbing ${over === j && drag !== null ? "outline outline-2 outline-black" : ""} ${drag === j ? "opacity-50" : ""}`}>
              {src ? (
                <img src={src} alt={item?.label || mb.room} draggable={false} data-testid={j === 0 ? `moodboard-hero-${i}` : undefined}
                  className={`w-full h-full object-cover transition-opacity ${imageBusy && j === 0 ? "opacity-40" : ""}`} />
              ) : <div className="w-full h-full flex items-center justify-center text-xs text-stone-400">No image</div>}
              <div className="absolute left-2 top-2 flex items-center gap-1 bg-white/85 backdrop-blur px-2 py-1 text-[10px] font-mono-lab uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity">
                <GripVertical size={10} /> {item?.label || "Image"}
              </div>
              {onRegenTile && (
                <button type="button" onClick={(e) => { e.stopPropagation(); onRegenTile(j); }} disabled={busyTile !== null && busyTile !== undefined} data-testid={`tile-regen-${i}-${j}`}
                  title="New option for this view" className="absolute right-2 top-2 bg-white/90 backdrop-blur p-1.5 opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black hover:text-white disabled:opacity-40">
                  <RefreshCw size={12} className={busyTile === j ? "animate-spin" : ""} />
                </button>
              )}
              {busyTile === j && <div className="absolute inset-0 bg-white/60 flex items-center justify-center text-[10px] font-mono-lab uppercase tracking-wider">Rendering…</div>}
            </div>
          );
        })}
      </div>
      <div className="text-[11px] text-stone-400 mt-2">Every tile is an AI option of this same space from a different viewpoint. Drag to swap positions; hover a tile and press ↻ for a new option of that view.</div>
    </div>
  );
}
